// extracted by mini-css-extract-plugin
export default {"disablePoint":"List_disablePoint__+wv-d","enablePoint":"List_enablePoint__bSGO-"};